import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useMarkingSummary } from '../../../api/hooks';

/** Compact dashboard link to the oldest worksheet with written answers to mark. */
export default function WrittenToMarkRow() {
  const { data } = useMarkingSummary();
  if (!data || data.total_to_mark <= 0 || data.exams.length === 0) return null;
  return (
    <Link to={`/worksheets/${data.exams[0].id}/marking`}
      className="flex min-h-[44px] items-center justify-between gap-3 rounded-[16px] border border-line bg-surface px-4 py-3 text-sm font-semibold text-ink no-underline shadow-card hover:bg-surface-2 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent">
      <span>Written answers to mark · {data.total_to_mark}</span>
      <ArrowRight size={18} strokeWidth={1.8} aria-hidden />
    </Link>
  );
}
